import { useSelector } from "react-redux";
import { selectCurrentEventCompanyPlan } from "modules/event/selectors";
import { isTrialCompleted } from "modules/companyPlanSettings/utils/trial";
import { EventPrechecks, PrecheckStatus } from "../constants";
import { PrecheckResult } from "../types";

export const useTrialExpiredCheck = (): PrecheckResult => {
  const eventCompanyPlan = useSelector(selectCurrentEventCompanyPlan);

  const trialExpired = isTrialCompleted(eventCompanyPlan);

  if (!eventCompanyPlan)
    return {
      name: EventPrechecks.TRIAL_EXPIRED,
      status: PrecheckStatus.PENDING,
    };

  return {
    name: EventPrechecks.TRIAL_EXPIRED,
    status: trialExpired ? PrecheckStatus.FAIL : PrecheckStatus.PASS,
  };
};
